"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import { APIDataSource } from "@/components/grid/data-source";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import DateFormat from "@/framework/timeformatter";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
let CoinLogs = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v7/coins/history")
    );
    this.searchData = "";
    this.searchDate = [
      // new Date().setMonth(new Date().getMonth() - 3),
      new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1e3 * 24 * 7),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1)
    ];
    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1);
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.setMonth(start.getMonth() - 1)).setDate(1));
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
    this.SearchInput = _.debounce((searchData) => __async(this, null, function* () {
      if (searchData !== null && searchData !== "") {
        this.gridController.query.params = {
          account: searchData
        };
      }
      if (searchData === null || searchData === "") {
        this.gridController.query.params = null;
      }
      yield this.gridController.search();
    }), 500);
    this.Search = _.debounce((search) => __async(this, null, function* () {
      console.log(search);
      if (search !== null) {
        let mintime = Date.parse(search[0]);
        let maxtime = Date.parse(search[1]);
        this.gridController.query.filter = `createdTime >= ${mintime};createdTime<=${maxtime}`;
      }
      if (search === null || (search == null ? void 0 : search.length) === 0) {
        this.gridController.query.filter = null;
      }
      yield this.gridController.search();
    }), 500);
  }
  // pickerOptions: object = {
  //   shortcuts: [
  //     {
  //       text: this.$t("loginlogs.nearweeks"),
  //       onClick(picker: any) {
  //         const end = new Date();
  //         const start = new Date();
  //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
  //         picker.$emit("pick", [start, end]);
  //       },
  //     },
  //   ],
  // };
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.sort = "createdTime,desc";
      this.gridController.query.filter = null;
      yield this.Search(this.searchDate);
    });
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
  exportGoldBean() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.confirm(this.$t("export_tip.export_info_content"), this.$t("export_tip.export_info_title"), {
          cancelButtonText: this.$t("export_tip.export_cancel"),
          confirmButtonText: this.$t("export_tip.export_confirm")
        });
        const exportWin = window.open("", "_self");
        const response = yield API.get(
          `api://base.auth/api/v7/export/coins/history`,
          {
            params: {
              page: this.gridController.query.current,
              search: this.gridController.query.filter,
              sort: this.gridController.query.sort,
              current: this.gridController.query.current,
              size: this.gridController.query.size
            }
          }
        );
        exportWin.location.href = response.data.download;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
};
CoinLogs = __decorateClass([
  Component({
    components: { UiGrid }
  })
], CoinLogs);
export {
  CoinLogs as default
};
